import { makeStyles, Theme } from "@material-ui/core";
import {
  h2,
  h4Medium,
  h5Semibold,
  h5Medium,
  h6Regular,
  h6Semibold,
} from "../../shared/typography";
import { pointer } from "../../shared/mixins";

export interface OrdersDetailsStyleProps {
  dir: "rtl" | "ltr";
}

export const useStyles = makeStyles<Theme, OrdersDetailsStyleProps>(
  (theme) => ({
    OrderDetailsContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 40,
      paddingTop: 16,
    },
    OrderDetailsGoBack: (props) => ({
      ...h5Semibold,
      color: "#80BB34",
      display: "flex",
      alignItems: "center",
      gap: 16,
      ...pointer,
      flexDirection: props.dir === "ltr" ? "row" : "row-reverse",
    }),
    OrderDetailsID: {
      padding: 0,
      margin: 0,
      ...h2,
    },
    orderDetailsIDContainer: {
      display: "flex",
      alignItems: "center",
      gap: 24,
    },
    subContainer: {
      display: "flex",
      gap: 40,
    },
    deliveriesContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 24,
    },
    deliveryTo: {
      display: "flex",
      flexDirection: "column",
      gap: 24,
      padding: "40px 0",
      borderBottom: "1px dashed rgba(21, 34, 47, 0.08)",
    },
    deliveryToHeader: {
      display: "flex",
      gap: 16,
    },
    deliveryToText: {
      ...h5Medium,
    },
    deliveryTruckIcon: {
      width: 24,
      height: 24,
    },
    customerDetails: {
      ...h6Regular,
      display: "flex",
      flexDirection: "column",
    },
    actionItems: {
      padding: "40px 0",
      display: "flex",
      flexDirection: "column",
      gap: 24,
    },
    copyOrderButton: {
      borderRadius: 16,
      background: "#80BB34",
      display: "flex",
      width: 222,
      padding: "14px 16px 18px 16px",
      justifyContent: "center",
      alignItems: "center",
      color: "#FFF",
      textAlign: "center",
      border: "none",
      ...h5Medium,
      ...pointer,
    },
    loaderContainer: {
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
    cancelledMsgCard: {
      display: "flex",
      padding: "16px 24px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: 16,
      borderRadius: 16,
      background: "rgba(21, 34, 47, 0.08)",
      maxWidth: 660,
      width: "100%",
      boxSizing: "border-box",
    },
    cancelledMsgHeader: {
      ...h6Semibold,
      color: "#15222F",
    },
    cancelledMsg: {
      ...h6Regular,
      color: "#15222F",
    },
    phoneNumber: (props) => ({
      direction: "ltr",
      display: "flex",
      justifyContent: props.dir === "ltr" ? "left" : "right",
    }),
    noOrderFound: {
      width: "100%",
      height: "90vh",
      display: "flex",
      flexDirection: "column",
      gap: 48,
      justifyContent: "center",
      alignItems: "center",
      ...h4Medium,
    },
  })
);
